<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import FontIcon from '@/components/FontIcon.vue';
import { EventBus, EventBusEvents } from '@/helpers/event-bus';

@Component({
  components: {
    FontIcon
  }
})
export default class VideoTrigger extends Vue {

  protected localeVideoKey: string | null = null;

  protected isPlaying: boolean = false;

  protected get videoUrl(): string | null {
    if (this.localeVideoKey === null) {
      return null;
    }
    if (this.$te(this.localeVideoKey)) {
      return this.$t(this.localeVideoKey).toString();
    }
    if (this.$te(this.localeVideoKey, 'en')) {
      return this.$t(this.localeVideoKey, 'en').toString();
    }
    return null;
  }

  protected get locale(): string {
    return this.$i18n.locale;
  }

  protected onVideoTrigger() {
    EventBus.$emit(EventBusEvents.playVideo, this.videoUrl);
  }

  protected onPlayVideo(videoUrl: string) {
    this.isPlaying = this.videoUrl === videoUrl;
  }

  protected created() {
    EventBus.$on(EventBusEvents.playVideo, this.onPlayVideo);
  }

  protected beforeDestroy() {
    EventBus.$off(EventBusEvents.playVideo, this.onPlayVideo);
  }

  @Watch('locale', { immediate: true })
  protected onLocaleChange(newVal: string, oldVal: string) {
    if (this.isPlaying && newVal !== oldVal) {
      this.onVideoTrigger();
    }
  }
}
</script>
<style lang="stylus">

</style>
